import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { IHeaderText } from "./header-text.model";

@Injectable({
  providedIn: "root",
})
export class HeaderTextService {
  private titulo: String | IHeaderText = { titulo: '', custom_title: false };
  private posicion: 'cabecera' | 'pantalla' = 'cabecera';

  /**
   * Getter for titulo
   */
  getTitulo(): String | Object {
    return this.titulo;
  }

  setTitulo(route: Router) {
    this.titulo = route.url;
    this.posicion = 'cabecera';
  }

  // Permitimos que 'title' pueda ser IHeaderText, null o undefined
  setCustomTitle(title?: IHeaderText | null) {
    if (!title) {
      // Si mandas null/undefined desde el ngOnDestroy, limpias el estado
      this.titulo = { titulo: '', custom_title: false };
      this.posicion = 'cabecera';
      return;
    }

    // Si viene el objeto, asignamos normalmente
    this.titulo = title;
    this.posicion = title.posicion || 'cabecera';
  }

  getPosicion(): 'cabecera' | 'pantalla' {
    return this.posicion;
  }

  setPosicion(pos: 'cabecera' | 'pantalla') {
    this.posicion = pos;
  }
}